// src/components/Manga/MangaNotFoundPage.js
import React from 'react';

const MangaNotFoundPage = () => {
  return (
    <div>
      <h2></h2>
      <p></p>
    </div>
  );
};

export default MangaNotFoundPage;
